/**
 * Query Keys Factory
 * Centralized query key management for type safety and consistency
 * Note: queryClient has been moved to src/config/queryClient.js for app-wide usage
 */
export const queryKeys = {
  // Tasks board queries
  tasks: {
    all: ['tasks'],
    board: (taskStages) => ['tasks', 'board', taskStages],
    column: (columnId, page) => ['tasks', 'column', columnId, page],
    manage: (columnId) => ['tasks', 'manage-column', columnId],
  },
  // Practice areas
  practiceAreas: {
    all: ['practice-areas'],
    list: () => ['practice-areas', 'list'],
  },
  // Task stages
  taskStages: {
    all: ['task-stages'],
    list: () => ['task-stages', 'list'],
  },
  // Users
  users: {
    all: ['users'],
    list: (status) => ['users', 'list', status],
  },
};
